import { useState } from 'react';
import Stick from 'react-stick';
import { locale as getLocale } from '@signavio/i18n';
import { useStyles } from '@signavio/ui';
import { Date } from '@signavio/ui/core';
import { utils } from '../../styles';
import DatePicker from './DatePicker';
import { jsx as _jsx } from "react/jsx-runtime";
function DateInput({
  locale = getLocale().replace('_', '-'),
  onChange,
  value = null,
  ...rest
}) {
  const style = useStyles(defaultStyle, {});
  const [showDatePicker, setShowDatePicker] = useState(false);
  return /*#__PURE__*/_jsx(Stick, {
    autoFlipVertically: true,
    node: showDatePicker && /*#__PURE__*/_jsx(DatePicker, {
      ...style('datePicker'),
      onChange: date => {
        onChange(date);
        setShowDatePicker(false);
      },
      value: value
    }),
    onClickOutside: () => setShowDatePicker(false),
    style: style,
    children: /*#__PURE__*/_jsx(Date, {
      ...rest,
      value: value,
      onChange: onChange,
      style: style('date'),
      culture: locale,
      onFocus: () => setShowDatePicker(true)
    })
  });
}
const defaultStyle = theme => ({
  node: {
    zIndex: 999
  },
  datePicker: {
    ...utils.border('1px', 'solid', theme.color.mono.lighter),
    ...utils.boxShadow()
  },
  date: {
    border: 'none',
    width: '100%',
    ...utils.input(theme)
  }
});
export default DateInput;